'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Circle component.
 */
var Circle = function Circle(_ref) {
  var size = _ref.size,
      filled = _ref.filled,
      props = (0, _objectWithoutProperties3.default)(_ref, ['size', 'filled']);
  return _react2.default.createElement(_Icon2.default, (0, _extends3.default)({ name: 'circle' + (!filled ? '-thin' : ''), size: size }, props));
};

Circle.propTypes = {
  size: _propTypes2.default.number,
  filled: _propTypes2.default.bool
};

Circle.defaultProps = {
  size: 24,
  filled: false
};

exports.default = Circle;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/Circle/index.js
// module id = 379
// module chunks = 0